import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Hide } from "./hide";
/**
 * Tree Component
 * @param {Object} params - component parameters.
 * @param {Array} param.nodes - A nested array of the tree eg: [{title:"Title 1",children:[{title:"Title 2"}]}].
 * @param {Function} [param.nrender = () => <span>{node.title}</span>] - A custom render function
 * @param {Function} [param.nclick = (node, open) => { }] - Node click call back function. This accept the node and state. eg; nclick = (_n, _o) => { }
 * @param {string} [param.childKey = children] - The key used to identify children node in nodes
 * @param {boolean} [param.flip = false] - used to change the location of the tree node opener
 * @param {boolean} [param.active = false] - if true, all the nodes will be opened by default
 * @returns React Tree Component
 */
export const Tree = ({ nodes = [], nrender = (n) => <span>{n.title}</span>, nicons={}, nclick = (_n, _o) => { }, childKey = "children", flip = false, active = false }) => {
    return (<ul className="list-unstyled tree-nodes">
        {nodes.map((v, i) => <TreeNode key={i} node={v} render={nrender} icons={nicons} childrenKey={childKey} click={nclick} flip={flip} active={active} />)}
    </ul>)
}
const TreeNode = ({ node = {}, render, icons, childrenKey, click, flip, active}) => {
    const [open, setOpen] = useState(node.active || active);
    const children = node[childrenKey] || [];
    const _icons = {
        ...{
            open: <FontAwesomeIcon icon={['fas', "fa-chevron-down"]} />,
            closed: <FontAwesomeIcon icon={['fas', "fa-chevron-right"]} />
        },
        ...icons,
    }
    const icon = (state) => {
        if (state) return _icons.open;
        return _icons.closed;
    }
    const _click = () => {
        click(node, !open);
        setOpen(!open);
    };
    return (<li>
        <div onClick={_click} className={`tree-node ${children.length ? "link" : ""}`}>
            <Hide state={!flip}>
                <div className="d-inline-block tree-node-content">{render(node)}</div>
            </Hide>
            <div className="tree-icon">
                {icon(open && children.length)}
            </div>
            <Hide state={flip}>
                <div className="d-inline-block tree-node-content">{render(node)}</div>
            </Hide>
        </div>
        <Hide state={!open && children.length}>
            <Tree nodes={children} nrender={render} nclick={click} childKey={childrenKey} flip={flip} />
        </Hide>
    </li>)
}